import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { ErnotsConfig, GetPageTitle } from "../../ErnotsConfig";
import { getModelMap } from "../../rest/slice";
import { Language } from "../../rest/models";
import { DictRequestStatusDisplay, RequestStatusDisplay } from "../CommonComponents";
import { Button, TextArea } from "../RequestRespectingInputs";
import { RestObjectDDL } from "../../rest/components/RestObjectDDL";
import { makeApiRequest } from "../../api_request/api_request";
import { RequestStatus } from '../../api_request/api_request';

export function ArbitraryText()
{
    const appDispatch = useAppDispatch();

    const [text, setText] = useState('');
    const [selectedLang, setSelectedLang] = useState('');
    const [request, setRequest] = useState<RequestStatus|undefined>(undefined);
    const langModels = getModelMap(useAppSelector, Language);

    const url = `arbitrary_text/`;

    useEffect(function()
    {
        const success = request?.success;
        const atid = request?.responseText;
        
        if (success && atid)
        {
            const code = langModels?.[selectedLang]?.gtrans_code ?? 'en';
            const url2 = ErnotsConfig.APIURLPrefix + url + '?atid=' + atid;
            const url3 = encodeURIComponent(url2);
            const url4 = `https://translate.google.com/translate?sl=auto&tl=${code}&hl=en&u=${url3}&client=webapp`;

            window.open(url4, '_blank');
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [request?.success, request?.responseText]);
    
    const hasData = langModels != null;
    if (!hasData)
    {
        return <DictRequestStatusDisplay modelClass={Language} />;
    }

    return (
    <div>
        <title>{GetPageTitle('Translate Arbitrary Text')}</title>

        <p>On this page, paste whatever you want. Translate it without being restricted by Google's 5000 character limit.</p>

        Target language:
        <RestObjectDDL
            name='language'
            modelClass={Language}
            property='name'
            hasEmptyOption={false}
            selection={selectedLang}
            handleChange={val => setSelectedLang(val)}/>
        <br/>
        <TextArea value={text} onChange={e => setText(e.currentTarget.value || '')}/>
        <br/>
        <Button name="text" onClick={function()
        {
            makeApiRequest({
                endpoint: url,
                method: 'POST',
                postData: {text},
                dispatch: appDispatch,
                lifeCycleCallback: setRequest
            });
        }}>Submit</Button>
        <RequestStatusDisplay request={request}/>
    </div>);
}